import { render, staticRenderFns } from "./detailProductModal.vue?vue&type=template&id=7dfe5308&scoped=true"
import script from "./detailProductModal.vue?vue&type=script&lang=js"
export * from "./detailProductModal.vue?vue&type=script&lang=js"
import style0 from "./detailProductModal.vue?vue&type=style&index=0&id=7dfe5308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfe5308",
  null
  
)

export default component.exports